import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import RegisterPage from './pages/RegisterPage';
import Login from './pages/Login';
import AdminLogin from './pages/AdminLogin';
import DashboardPanel from './pages/dashboard';
import SearchPage from './pages/SearchPage';
import TrackService from './pages/track-service';
import DownloadPage from './pages/DownloadPage';
import TermsConditions from './pages/TermsConditions';
import ReturnPolicy from './pages/ReturnPolicy';
import SupportPolicy from './pages/SupportPolicy';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ScrollToHash from "./components/ScrollToHash";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './styles/style.css';

function App() {
  return (
    <Router>
      <ScrollToHash />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin_login" element={<AdminLogin />} />
        <Route path="admin/dashboard" element={<DashboardPanel />} />
        <Route path="/search-page" element={<SearchPage />} />
        <Route path="/track-service" element={<TrackService />} />
        <Route path="/download-page" element={<DownloadPage />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/return-policy" element={<ReturnPolicy />} />
        <Route path="/support-policy" element={<SupportPolicy />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </Router>
  );
}

export default App;